import { useGetApiV1ExamExamitemidPreview } from '@/shared/api/generated';
import type { ExamItemPreviewViewModel } from '@/shared/api/generated/types/ExamItemPreviewViewModel';

/**
 * Hook para pré-visualizar uma questão individual com suas alternativas.
 *
 * Usa o endpoint de preview da questão que retorna o componente, enunciado
 * e lista de alternativas (`examTypeList`) quando aplicável.
 *
 * @param examItemId - ID da questão. Pass 0 to disable the query.
 * @returns Dados de preview da questão com estado de loading/error
 *
 * @example
 * ```tsx
 * const { preview, isLoading } = useExamQuestionPreview(questionId);
 * const options = preview?.examTypeList ?? [];
 * ```
 */
export function useExamQuestionPreview(examItemId: number) {
  const query = useGetApiV1ExamExamitemidPreview(examItemId, {
    query: { enabled: examItemId > 0 },
  });

  return {
    preview: (query.data ?? null) as ExamItemPreviewViewModel | null,
    isLoading: query.isLoading,
    isError: query.isError,
  } as const;
}
